function showpopup(html) {
    $('#popup-modal-container').html(html);
    $('#popup-modal').toggle();
}

function popupok(element) {
    $('#popup-modal').toggle();
}